import { __awaiter } from "tslib";
import { validate } from "jsonschema";
import { max } from "ramda";
class SchemaMigrationAdapter {
    constructor(schemas, migrationFunction, wrappedAdapter) {
        this.schemas = schemas;
        this.migrationFunction = migrationFunction;
        this.wrappedAdapter = wrappedAdapter;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.wrappedAdapter.init();
        });
    }
    set(contentPath, content) {
        return __awaiter(this, void 0, void 0, function* () {
            const validationResult = validate(content, this.schemas[this.schemas.length - 1]);
            if (validationResult.valid) {
                return this.wrappedAdapter.set(contentPath, content);
            }
            throw new Error(validationResult.errors.toString());
        });
    }
    has(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.wrappedAdapter.has(contentId);
        });
    }
    get(contentId) {
        return __awaiter(this, void 0, void 0, function* () {
            const content = yield this.wrappedAdapter.get(contentId);
            if (content === null) {
                return null;
            }
            const arrayMaxIndex = this.schemas.length - 1;
            if (validate(content, this.schemas[arrayMaxIndex]).valid) {
                return content;
            }
            if (this.schemas.length === 1) {
                throw new Error("There is only on schema and the data is not valid");
            }
            const results = this.schemas.map((schema) => {
                return validate(content, schema).valid;
            });
            const indexOfLastTrueValues = results
                .map((value, idx) => {
                if (value) {
                    return idx;
                }
                return -1;
            })
                .filter((value) => value !== -1)
                .sort(max);
            const indexOfLastTrueValue = indexOfLastTrueValues.length > 0 ? indexOfLastTrueValues[0] : 0;
            let updatedData = null;
            for (let i = indexOfLastTrueValue; i < arrayMaxIndex; i += 1) {
                updatedData = this.migrationFunction(i + 1, updatedData !== null && updatedData !== void 0 ? updatedData : content);
                const value = validate(updatedData, this.schemas[i + 1]);
                if (!value.valid) {
                    throw new Error("migration function failed to return a valid value");
                }
            }
            return updatedData;
        });
    }
}
export default SchemaMigrationAdapter;
